const initialState = {
  fetching: false,
  fetched: false,
  data: [],
  filter: {
    collaborators: []
  },
  error: null,
  months: [
    "JAN",
    "FEV",
    "MAR",
    "AVR",
    "MAI",
    "JUN",
    "JUL",
    "AOU",
    "SEP",
    "OCT",
    "NOV",
    "DEC"
  ],
  selectedCollaborator: "",
  tab: null
};

export const calendarTableReducer = (state = initialState, action) => {
  switch (action.type) {
    case "INIT_COLLABORATOR_CALENDAR": {
      return {
        ...state,
        fetching: false,
        fetched: false,
        data: [],
        error: null
      };
    }
    case "SET_COLLABORATOR_CALENDAR_TAB": {
      return {
        ...state,
        tab: action.item
      };
    }
    case "SET_SELECTED_COLLABORATOR_NAME": {
      return {
        ...state,
        selectedCollaborator: action.name
      };
    }
    case "FETCH_COLLABORATORS_CALENDAR_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_COLLABORATORS_CALENDAR_FULFILLED": {
      let data = action.payload;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        data: data
      };
    }
    case "FETCH_COLLABORATORS_CALENDAR_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        data: [],
        fetching: false,
        error
      };
    }
    default:
      return state;
  }
};

const initialSynthesisState = {
  fetching: false,
  fetched: false,
  data: [],
  resultCount: 0,
  error: null,
  columnsHours: ["Heures à prester", "solde", "Budget affecté"],
  columnsNumbers: [
    "SUPERVISOR",
    "GD",
    "GE",
    "SE",
    "SCAN_OP",
    // "Délégué",
    // "Orphelin",
    "Total"
  ]
};
export const synthesisTableReducer = (
  state = initialSynthesisState,
  action
) => {
  switch (action.type) {
    case "INIT_COLLABORATOR_SYNTHESIS": {
      return {
        ...state,
        fetching: false,
        fetched: false,
        data: [],
        resultCount: 0,
        error: null
      };
    }
    case "FETCH_COLLABORATORS_SYNTHESIS_PENDING": {
      return { ...state, resultCount: 0, fetching: true };
    }
    case "FETCH_COLLABORATORS_SYNTHESIS_FULFILLED": {
      let data = action.payload;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        resultCount: data["count"],
        data: data
      };
    }
    case "FETCH_COLLABORATORS_SYNTHESIS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        data: [],
        resultCount: 0,
        fetching: false,
        error
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/calendar-table.js